var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfirm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.5 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.5,17c-1.36.06-2.68-.52-3.54-1.57-.59-.73-.93-1.63-.96-2.57v-2.88c0-2.51,1.6-4.07,3.68-5.85.76-.69,1.39-1.51,1.86-2.42.5-.88.97-1.7,1.96-1.7.75.05,1.38.58,1.57,1.31.25.81.22,1.69-.1,2.47-.24.63-.59,1.21-1.03,1.72h3.55c1.05-.06,1.94.75,2,1.79,0,.07,0,.14,0,.21-.01.57-.24,1.12-.63,1.54.4.38.63.9.63,1.46,0,.64-.3,1.25-.83,1.62.22.34.33.73.33,1.13-.01.73-.4,1.4-1.02,1.78-.18,1.21-1.5,1.97-3.48,1.97h-4ZM7.5,1c-.37,0-.6.33-1.09,1.2-.52,1.01-1.22,1.92-2.08,2.68-1.95,1.67-3.33,3.01-3.33,5.09v2.88c.07,1.81,1.59,3.22,3.39,3.15.04,0,.07,0,.11,0h4c.93,0,2.5-.26,2.5-1.25,0-.2.12-.38.29-.46.4-.2.67-.59.71-1.04,0-.33-.15-.64-.41-.85-.14-.1-.22-.28-.2-.45.02-.17.13-.33.28-.4.73-.34.82-.74.82-1.05,0-.41-.24-.77-.62-.93-.16-.07-.28-.22-.3-.39-.03-.17.04-.35.18-.46.41-.28.68-.73.74-1.23.05-.5-.31-.95-.8-1-.07,0-.13,0-.2,0h-3.38c-.5,0-1,.06-1.49.19-.23.06-.47-.04-.58-.25-.11-.21-.05-.47.13-.62,1.96-1.57,2.27-3.23,1.94-4.18-.14-.39-.38-.64-.63-.64Z",
    strokeWidth: 0
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confirm.390673f3ca4c3db2a4116169d71fee08.svg";